import React from 'react';
import { Alert, Row } from 'antd';
import { useLocation } from 'react-router-dom';

export default function DataError({ useGenericMessage = false }) {
  const location = useLocation();

  let message;
  if (useGenericMessage) {
    message = 'Unable to load data. Please try again later';
  } else {
    const pageName = location.pathname.split('/')[1];
    message = 'Unable to load ' + pageName + ' data. Please try again later';
  }

  return (
    <Row justify='center' align='middle' className='mg-top-30'>
      <Alert message={message} type='error' />
    </Row>
  );
}
